const SvgSlotTime = () => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_17356_20708)">
        <path
          d="M9.5 2C5.36452 2 2 5.36453 2 9.5C2 13.6355 5.36452 17 9.5 17C13.6355 17 17 13.6355 17 9.5C17 5.36453 13.6355 2 9.5 2ZM9.5 3.125C13.0275 3.125 15.875 5.97252 15.875 9.5C15.875 13.0275 13.0275 15.875 9.5 15.875C5.97252 15.875 3.125 13.0275 3.125 9.5C3.125 5.97252 5.97252 3.125 9.5 3.125ZM8.92871 4.99194C8.77965 4.99427 8.63762 5.05567 8.5338 5.16265C8.42998 5.26963 8.37286 5.41344 8.375 5.5625V9.6875C8.37503 9.83667 8.43431 9.97973 8.53979 10.0852L10.4148 11.9602C10.4666 12.0142 10.5287 12.0573 10.5974 12.087C10.6661 12.1167 10.74 12.1324 10.8149 12.1331C10.8897 12.1339 10.9639 12.1197 11.0332 12.0914C11.1025 12.0631 11.1655 12.0213 11.2184 11.9684C11.2713 11.9155 11.3131 11.8525 11.3414 11.7832C11.3697 11.7139 11.3839 11.6397 11.3831 11.5649C11.3824 11.49 11.3667 11.4161 11.337 11.3474C11.3073 11.2787 11.2642 11.2166 11.2102 11.1648L9.5 9.45459V5.5625C9.50108 5.48721 9.48704 5.41248 9.4587 5.34272C9.43036 5.27296 9.38831 5.2096 9.33503 5.15639C9.28176 5.10318 9.21834 5.06121 9.14855 5.03296C9.07875 5.00472 9.004 4.99077 8.92871 4.99194Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17356_20708">
          <rect width="18" height="18" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgSlotTime;
